import { atom, RecoilState } from 'recoil';

export type LayoutPreset = 'classic' | 'cockpit' | 'focus' | 'split';

export const LAYOUT_PRESETS: Array<{
  id: LayoutPreset;
  label: string;
  description: string;
}> = [
  {
    id: 'classic',
    label: 'Classic',
    description: 'Drag-and-drop split panes. Resize every edge.'
  },
  {
    id: 'cockpit',
    label: 'Cockpit',
    description: 'Chat on the left, graph + terminal stacked on the right.'
  },
  {
    id: 'focus',
    label: 'Focus',
    description: 'Big chat, graph/terminal tucked into a slim right rail.'
  },
  {
    id: 'split',
    label: 'Split',
    description: 'Chat on top, graph and terminal side-by-side below.'
  }
];

const STORAGE_KEY = 'layoutPreset';

const getInitial = (): LayoutPreset => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'classic' || raw === 'cockpit' || raw === 'focus' || raw === 'split') {
      return raw;
    }
  } catch {
    // ignore localStorage errors (private mode, quota, etc.)
  }
  return 'classic';
};

export const layoutPresetState: RecoilState<LayoutPreset> = atom<LayoutPreset>({
  key: 'LayoutPreset',
  default: getInitial(),
  effects: [
    ({ onSet }) => {
      onSet((next) => {
        try {
          localStorage.setItem(STORAGE_KEY, next);
        } catch {
          // ignore
        }
      });
    }
  ]
});
